module.exports = __webpack_public_path__ + "static/media/cheekPuff.32afedcd.obj";